import { HttpErrorResponse } from '@angular/common/http';
import { Component, Inject, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { ToastrService } from 'ngx-toastr';
import { DefaultGUID, GenderType, RoleName } from 'src/app/@shared/constants/Constant';
import { isAdminDomainEmail } from '@utils/admin-email.util';
import { ILoggedInUserViewModel } from 'src/app/model/common.model';
import { FilesService } from 'src/app/service/files.service';
import { MemberService } from 'src/app/service/member.service';
import { IAssignedRole, MemberPayload } from 'src/app/service/memeber.model';
import { StateViewModel } from 'src/app/service/state.model';
import { VendorService } from 'src/app/service/vendor.service';

declare var $: any;

@Component({
  selector: 'app-add-edit-member',
  templateUrl: './add-edit-member.component.html',
  styleUrls: ['./add-edit-member.component.css'],
})
export class AddEditMemberComponent implements OnInit {
  public user: ILoggedInUserViewModel;
  public userRole = RoleName;
  public loader: boolean = false;
  public isMemberEdit: boolean;
  public isDifferentUserName = false;
  public memberId: string;
  public memberImage: any;
  public imageName: any;
  public emailError: boolean = false;
  public isFileUpload: boolean = false;
  public isEmailErrorForExecutiveAdminRole = false;
  public editMemberProfile: any;
  public cityList: any = [];
  public roleList = [];
  public StateList: StateViewModel[] = [];
  public selectedFileName: string = '';
  public fileDataValue: FormData;
  public isVendor: boolean;
  public isCustomer: boolean;
  public userRoleType: string;
  public memberDetail: MemberPayload = {
    businessUnitId: DefaultGUID,
    userName: '',
    email: '',
    profilePicture: '',
    firstName: '',
    middleName: '',
    lastName: '',
    contact: {
      contactId: DefaultGUID,
      emailId: '',
      phoneNumber: '',
      homeNumber: '',
      workNumber: '',
      lastUpdatedOn: new Date(),
      lastUpdatedBy: DefaultGUID,
      createdOn: new Date(),
      createdBy: DefaultGUID,
    },
    address: {
      addressId: DefaultGUID,
      streetAddress: '',
      city: DefaultGUID,
      stateId: DefaultGUID,
      zipcode: '',
      addressLocationType: '',
      isGlobal: false,
    },
    memberType: null,
    description: '',
    createdBy: 0,
    lastUpdatedBy: 0,
    createdOn: new Date(),
    lastUpdatedOn: new Date(),
    systemRole: [],
    files: [],
    organizationType: DefaultGUID,
    password: '',
    isGuestUser: false,
    height: 0,
    weight: 0,
    dateOfBirth: new Date(),
    gender: null,
    jobTitle: '',
    isCode3Certification: false,
  };
  first: boolean;
  fileLoader: boolean;
  selectMemberIndex: any;
  selectedIndex: any;
  selectedRow: any;
  selectedDiv: string;
  memberHeightFeet: number;
  memberHeightInch: number;
  memberDOB: any;
  public isDefaultRoleSelected: boolean;
  public assignedDefaultRole: string;
  public assignedMultipleRoles: Set<string> = new Set();
  public genderType = GenderType;

  constructor(
    private _memberService: MemberService,
    private _vendorService: VendorService,
    public dialogRef: MatDialogRef<AddEditMemberComponent>,
    @Inject(MAT_DIALOG_DATA)
    public dialogData: {
      headerName: string;
      index: number;
      memberId: string;
      isEdit: boolean;
      businessUnitId: string;
    },
    private _toaster: ToastrService,
    private _fileService: FilesService,
  ) {}

  ngOnInit() {
    this.loader = true;
    this.user = JSON.parse(localStorage.getItem('user'));
    this.isVendor = this.user.role == RoleName.VendorAdmin || this.user.role == RoleName.VendorCoordinator;
    this.isCustomer = this.user.role == RoleName.CustomerAdmin || this.user.role == RoleName.CustomerCoordinator;
    this.userRoleType = this.isVendor ? 'Vendor' : this.isCustomer ? 'Customer' : 'Member';
    this.fetchRoleDetail(this.userRoleType);
    this.getStateList();
    this.selectMemberDetail(this.dialogData.memberId, this.dialogData.index, this.dialogData.isEdit);
  }

  selectMemberDetail(memberId: string, index: number, isEdit: boolean) {
    this.first = true;
    this.isMemberEdit = isEdit;
    if (this.isMemberEdit) {
      this.fetchMemberDetailByMemberId(memberId, index);
    } else {
      this.memberDetail.businessUnitId = this.dialogData.businessUnitId;
    }
  }

  fetchMemberDetailByMemberId(memberId, index, GuestUser?: string) {
    this._vendorService.fetchMemberDetailById(memberId).subscribe((response) => {
      this.memberDataFill(response, index, GuestUser);
      this.loader = false;
    });
  }

  memberDataFill(memberDetail, index?, GuestUser?: string) {
    let value = memberDetail.phoneNumber.replace(/[^0-9]/g, '');
    let newnum = '(' + value.substring(0, 3) + ') ' + value.substring(3, 6) + '-' + value.substring(6, 10);
    memberDetail.phoneNumber = newnum;
    this.selectMemberIndex = memberDetail.memberId;
    this.selectedIndex = memberDetail.memberId;
    this.selectedRow = index;
    this.selectedDiv = 'Member';
    this.memberId = memberDetail.memberId;
    this.memberHeightFeet =
      memberDetail.height == null || memberDetail.height == undefined ? 0 : Math.floor(parseInt(memberDetail.height) / 12);
    this.memberHeightInch = memberDetail.height == null || memberDetail.height == undefined ? 0 : parseInt(memberDetail.height) % 12;
    this.memberDetail = {
      businessUnitId: this.dialogData.businessUnitId,
      email: '',
      userName: '',
      profilePicture: '',
      firstName: memberDetail.firstName,
      middleName: memberDetail.middleName,
      lastName: memberDetail.lastName,
      contact: {
        contactId: DefaultGUID,
        emailId: memberDetail.emailID,
        phoneNumber: memberDetail.phoneNumber,
        homeNumber: '',
        workNumber: '',
        lastUpdatedOn: new Date(),
        lastUpdatedBy: DefaultGUID,
        createdOn: new Date(),
        createdBy: DefaultGUID,
      },
      address: {
        addressId: DefaultGUID,
        streetAddress: memberDetail.streetAddress,
        city: memberDetail.city,
        stateId: memberDetail.stateId,
        zipcode: memberDetail.zipcode,
        addressLocationType: memberDetail.addressLocationType,
        isGlobal: memberDetail.isGlobal,
      },
      memberType: memberDetail.memberType,
      description: memberDetail.description,
      createdBy: 0,
      lastUpdatedBy: 0,
      createdOn: new Date(),
      lastUpdatedOn: new Date(),
      systemRole: memberDetail.roleId == null || memberDetail.roleId == undefined ? '' : memberDetail.roleId,
      files: [],
      organizationType:
        memberDetail.organizationType == null || memberDetail.organizationType == undefined ? DefaultGUID : memberDetail.organizationTypeId,
      password: '',
      isGuestUser: GuestUser != null || GuestUser != undefined || GuestUser == 'GuestUser' ? true : false,
      height: memberDetail.height == null || memberDetail.height == undefined ? 0 : memberDetail.height,
      weight: memberDetail.weight == null || memberDetail.weight == undefined ? 0 : memberDetail.weight,
      dateOfBirth: new Date(),
      gender: memberDetail.gender,
      jobTitle: '',
      isCode3Certification: false,
    };
    this.memberDOB = memberDetail.dateOfBirth == null || memberDetail.dateOfBirth == undefined ? '' : memberDetail.dateOfBirth;
    this.memberImage = memberDetail.profile != null ? memberDetail.profile.filePath : './assets/img/avatar5.png';
    this.imageName = memberDetail.profile != null ? memberDetail.profile.displayName : undefined;
    if (memberDetail.stateId != null) {
      this.getCityBystate(memberDetail.stateId);
    }
  }

  closeModel() {
    this.memberImage = './assets/img/avatar5.png';
    this.imageName = undefined;
    this.dialogRef.close();
  }

  resetForm(addEditMembersForm: any) {
    addEditMembersForm.resetForm();
    this.emailError = false;
    this.isDifferentUserName = false;
  }

  public selectedProfilePic: File;

  public uploadMemberProfile(event: Event, element, operationType: string, flag?) {
    const inputFiles: FileList = (event.target as HTMLInputElement).files;

    const files = inputFiles[0];
    this.selectedProfilePic = files;
    this.isFileUpload = true;
  }

  readURL(input) {
    this.imageName = undefined;
    this.selectedFileName = '';
    var temThis = this;
    target: EventTarget;
    if (input.files && input.files[0]) {
      this.selectedFileName = input.files[0].name;
      var reader = new FileReader();

      reader.onload = function (e) {
        let target: any = e.target;
        let content: string = target.result;
        temThis.memberImage = content;
      };
      reader.readAsDataURL(input.files[0]); // convert to base64 string
    }
  }

  checkUserExist(data: string) {
    this._memberService.memberCheckByEmail(data).subscribe(
      (response) => {
        this.emailError = response;
      },
      (error) => {
        console.log('error: ', error);
      },
    );
  }

  checkAdminRole(roleName: string) {
    if (roleName != RoleName.ExecutiveAdmin) {
      this.isEmailErrorForExecutiveAdminRole = false;
    }
  }

  fetchRoleDetail(userRoleType: string) {
    this._vendorService.getAllRole(userRoleType).subscribe((response) => {
      this.roleList = response;
      this.loader = false;
    });
  }

  getStateList() {
    this._vendorService.getStateList().subscribe(
      (response) => {
        this.StateList = response;
        this.loader = false;
      },
      (error) => {
        console.log(error);
        this.loader = false;
      },
    );
  }

  getCityBystate(stateId: string) {
    this.loader = true;
    this._vendorService.getCityByState(stateId).subscribe((responce) => {
      this.cityList = responce;
      this.loader = false;
    });
  }

  saveData(event) {
    if (event.form.valid && !this.isMemberEdit && !this.isDifferentUserName) {
      this.isDefaultRoleSelected = !!this.assignedDefaultRole;
      if (this.checkEmailValidForAdmin(event.form.value.email) && this.isDefaultRoleSelected) {
        this.closeModel();
        this._memberService.isLoadingSubject$.next(true);
        this.addEditMember(event);
      }
    } else if (event.form.valid && (this.isMemberEdit || this.isDifferentUserName)) {
      this.closeModel();
      this._memberService.isLoadingSubject$.next(true);
      this.addEditMember(event);
    }
  }

  checkEmailValidForAdmin(email: string): Boolean {
    let assignedRoles: string[] = [];
    assignedRoles.push(this.assignedDefaultRole);
    Array.from(this.assignedMultipleRoles).forEach((roleId) => {
      assignedRoles.push(roleId);
    });
    const roleName = this.roleList.find((role) => {
      return !!assignedRoles.find((roleId) => role.roleid === roleId && role.rolename === RoleName.ExecutiveAdmin);
    })?.rolename;

    if (roleName == RoleName.ExecutiveAdmin) {
      if (isAdminDomainEmail(email)) {
        this.isEmailErrorForExecutiveAdminRole = false;
        return true;
      } else {
        this.isEmailErrorForExecutiveAdminRole = true;
        return false;
      }
    }
    this.isEmailErrorForExecutiveAdminRole = false;
    return true;
  }

  public addEditMember(event: any) {
    this.emailError = false;
    this.memberDetail.contact.phoneNumber = this.memberDetail.contact.phoneNumber.replace(/[^0-9\s]/g, '');
    this.memberDetail.contact.phoneNumber = this.memberDetail.contact.phoneNumber.replace(/\s/, '');
    this.memberDetail.isGuestUser = this.isDifferentUserName;
    if (this.dialogData.headerName == 'Edit Member') {
      this.memberDetail.systemRole = [];
      this._vendorService.updateMemberDetail(this.memberDetail, this.memberId).subscribe(
        () => {
          this.attachDocument(this.memberId, 'editProfile', event);
        },
        (error) => {
          console.log(error);
          this._memberService.isLoadingSubject$.next(false);
          this.loader = false;
          this._toaster.warning('Something went wrong while updating member details!', 'Warning', {
            timeOut: 6000,
            positionClass: 'toast-top-center',
          });
        },
      );
    } else {
      if (!this.memberDetail.isGuestUser) {
        this.memberDetail.userName = this.memberDetail.contact.emailId;
        this.memberDetail.systemRole = this.rolePayload();
      } else {
        this.memberDetail.systemRole = [];
      }

      if (this.memberDetail.memberType == null) {
        this.memberDetail.memberType =
          this.user.role == RoleName.VendorAdmin || this.user.role == RoleName.VendorCoordinator ? 'Vendor' : 'Member';
      }
      this._vendorService.createMember(this.memberDetail, DefaultGUID).subscribe(
        (response) => {
          this.attachDocument(response, 'profile', event);
        },
        (error: HttpErrorResponse) => {
          this._toaster.warning(
            error.error?.errors?.[0] ?? error.error?.message ?? 'Something went wrong while adding member! Please try again',
            'Warning',
            {
              timeOut: 6000,
              positionClass: 'toast-top-center',
            },
          );
          this._memberService.isLoadingSubject$.next(false);
          this.loader = false;
        },
      );
    }
  }

  attachDocument(memberID, id, form) {
    let accessToken = localStorage.getItem('AccessToken');
    if (this.isFileUpload) {
      this.fileDataValue = new FormData();
      try {
        this.fileDataValue.append(this.selectedProfilePic.name, this.selectedProfilePic, this.selectedProfilePic.type);
        id == 'profile'
          ? this.uploadFile('profile', 'Member', memberID, this.fileDataValue, form)
          : this.editProfile('profile', 'Member', memberID, this.fileDataValue, form);
      } catch (error) {
        console.log(error);
        this.loader = false;
        this._memberService.$memberUpdates.next(false);
        form.resetForm();
      }
    } else {
      form.resetForm();
      this.loader = false;
      this._memberService.$memberUpdates.next(false);
      if (this.dialogData.headerName == 'Edit Member') {
        this.successMessage('Member Updated Successfully');
      } else {
        this.successMessage('Member Added Successfully');
      }
    }
  }

  uploadFile(fileType: string, entityTableName: string, entityTableValue: string, fileInfo: FormData, form: NgForm) {
    this._fileService.uploadFile(fileType, entityTableName, entityTableValue, fileInfo).subscribe(
      (response) => {
        this.loader = false;
        this._memberService.$memberUpdates.next(false);
        form.resetForm();
        this.successMessage('Member Added Successfully');
      },
      (error) => {
        this.loader = false;
        console.log(error);
        this._memberService.$memberUpdates.next(false);
        form.resetForm();
        this._toaster.warning('Unable to Upload File!', 'Warning', { timeOut: 6000, positionClass: 'toast-top-center' });
      },
    );
  }

  editProfile(fileType: string, entityTableName: string, entityTableValue: string, fileInfo: FormData, form: NgForm) {
    this._fileService.editProfilePictureAsync(fileType, entityTableName, entityTableValue, fileInfo).subscribe(
      (response) => {
        this.loader = false;
        this._memberService.$memberUpdates.next(false);
        form.resetForm();
        this.successMessage('Member Updated Successfully');
      },
      (error) => {
        this.loader = false;
        console.log(error);
        this._memberService.$memberUpdates.next(false);
        form.resetForm();
        this._toaster.warning('Unable to Upload File!', 'Warning', { timeOut: 6000, positionClass: 'toast-top-center' });
      },
    );
  }

  successMessage(msg) {
    this._toaster.success(msg, 'Success!', {
      timeOut: 2000,
      positionClass: 'toast-top-center',
    });
  }

  selectMultipleRole(event: any) {
    if (event.target.checked) {
      this.assignedMultipleRoles.add(event.target.value as string);
    } else {
      this.assignedMultipleRoles.delete(event.target.value as string);
    }
  }

  rolePayload(): IAssignedRole[] {
    let rolePayload: IAssignedRole[] = [];
    let roles = Array.from(this.assignedMultipleRoles);
    roles = roles.filter((roleId) => roleId != this.assignedDefaultRole);
    roles.forEach((assignedRoleId) => {
      rolePayload.push({
        roleId: assignedRoleId,
        roleName: null,
        isDefaultRole: false,
      });
    });
    rolePayload.push({
      roleId: this.assignedDefaultRole,
      roleName: null,
      isDefaultRole: true,
    });
    return rolePayload;
  }
}
